import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=274f0b0b&scoped=true"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
import style0 from "./SidebarSharePlugin.vue?vue&type=style&index=0&id=274f0b0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f0b0b",
  null
  
)

export default component.exports